export const reducingReagents = {
  "1,2-Bis(tert-butylthio)ethane Borane": "CC(SCCSC(C)(C)C)(C)C.B",
  "Benzyltriethylammonium Borohydride": "CC[N+](CC)(CC1=CC=CC=C1)CC.[BH4-]",
  "Borane - 2-Methylpyridine Complex": "CC1=NC=CC=C1.B",
  "Borane - 5-Ethyl-2-methylpyridine Complex": "CC1=NC=C(CC)C=C1.B",
  "Borane - Ammonia Complex": "B.N",
  "Borane - Diisopropylamine Complex": "CC(C)NC(C)C.B",
  "Borane - Morpholine Complex": "O1CCNCC1.B",
  "Borane - Pyridine Complex": "C1=CN=CC=C1.B",
  "Borane - Tetrahydrofuran Complex": "B.C1COCC1",
  "Borane - tert-Butylamine Complex": "NC(C)(C)C.B",
  "Dicyclohexylamine Borane": "C1(NC2CCCCC2)CCCCC1.B",
  "Diethyl 1,4-Dihydro-2,6-dimethyl-3,5-pyridinedicarboxylate": "O=C(C1=C(C)NC(C)=C(C(OCC)=O)C1)OCC",
  "Dimethyl Sulfide Borane": "CSC.B",
  "Dimethylamine Borane": "CNC.B",
  "Di-tert-butyl 1,4-Dihydro-2,6-dimethyl-3,5-pyridinedicarboxylate": "O=C(C1=C(C)NC(C)=C(C(OC(C)(C)C)=O)C1)OC(C)(C)C",
  "DL-Dithiothreitol": "SC[C@H]([C@@H](CO)O)S",
  "Ethyl Chloroglyoxylate": "O=C(Cl)C(OCC)=O",
  "Lithium Aluminum Hydride": "[Li+].[Al+3].[H-].[H-].[H-].[H-]",
  "Lithium Borohydride ": "[Li+].[BH4-]",
  "Lithium Triethylborohydride": "CC[BH-](CC)CC.[Li+]",
  "Lithium Tri-tert-butoxyaluminum Hydride": "CC(O[Al](OC(C)(C)C)OC(C)(C)C)(C)C.[Li+].[H-]",
  "Methyl Chloroglyoxylate": "O=C(Cl)C(OC)=O",
  "N,N-Diethylaniline Borane": "CCN(CC)C1=CC=CC=C1.B",
  "N'-Isopropylidene-2-nitrobenzenesulfonohydrazide": "O=S(C1=CC=CC=C1[N+]([O-])=O)(NN=C(C)C)=O",
  "Potassium Bis(1-pyrazolyl)borohydride": "N1([BH2-]N2N=CC=C2)N=CC=C1.[K+]",
  "Potassium Borohydride": "[K+].[BH4-]",
  "Potassium Tris(1-pyrazolyl)borohydride": "[BH-](N1N=CC=C1)(N2N=CC=C2)N3N=CC=C3.[K+]",
  "Samarium(II) Iodide": "[Sm+2].[I-].[I-]",
  "Sodium Bis(2-methoxyethoxy)aluminum Dihydride": "COCCO[Al+]OCCOC.[Na+].[H-].[H-]",
  "Sodium Borohydride": "[Na+].[BH4-]",
  "Sodium Cyanoborohydride [Reducing Agent]": "[BH3-]C#N.[Na+]",
  "Sodium Hydride": "[Na+].[H-]",
  "Sodium Triacetoxyborohydride": "O=C(O[BH-](OC(C)=O)OC(C)=O)C.[Na+]",
  "Sodium Tris(1,1,1,3,3,3-hexafluoroisopropoxy)borohydride": "FC(F)(C(C(F)(F)F)O[BH-](OC(C(F)(F)F)C(F)(F)F)OC(C(F)(F)F)C(F)(F)F)F.[Na+]",
  "Tetrabutylammonium Borohydride": "CCCC[N+](CCCC)(CCCC)CCCC.[BH4-]",
  "Tetraethylammonium Borohydride": "CC[N+](CC)(CC)CC.[BH4-]",
  "Tetramethylammonium Borohydride": "C[N+](C)(C)C.[BH4-]",
  "Tetramethylammonium Triacetoxyborohydride": "C[N+](C)(C)C.O=C(O[BH-](OC(C)=O)OC(C)=O)C",
  "Triethylamine Borane": "CCN(CC)CC.B",
  "Triethylsilane": "CC[SiH](CC)CC",
  "Triisopropylsilane": "CC([SiH](C(C)C)C(C)C)C",
  "Trimethylamine Borane": "CN(C)C.B",
  "Triphenylphosphine Borane": "P(C1=CC=CC=C1)(C2=CC=CC=C2)C3=CC=CC=C3.B",
  "Triphenylsilane": "[SiH](C1=CC=CC=C1)(C2=CC=CC=C2)C3=CC=CC=C3",
  "Tris(2-carboxyethyl)phosphine Hydrochloride": "O=C(CCP(CCC(O)=O)CCC(O)=O)O.[H]Cl",
  "Zirconocene Chloride Hydride": "[Del][Zr+2][Del].c1cccc1.c2cccc2.[Cl-].[H-]"
}